module.exports = __webpack_public_path__ + "img/widevine-logo.53f36e00.svg";